import React from 'react';
import Count from 'react-countup';

import { Button, Box, GreenBox, WhiteBox } from './styles';

interface CounterDTO {
  data: number;
  duration: number;
  setActiveFilter: any;
  active: number;
  text: string;
  type: number;
}

const Counter = ({
  data,
  duration,
  setActiveFilter,
  text,
  type,
  active,
}: CounterDTO) => {
  return (
    <Button
      onClick={() => {
        setActiveFilter(type);
      }}
    >
      <Box>
        <GreenBox>
          <h1 style={{ transition: '1s', font: '500 30px Roboto' }}>
            <Count end={data} duration={duration} />
          </h1>
        </GreenBox>
        <WhiteBox
          style={{
            paddingLeft: 35,
            paddingRight: 35,
            border: `2px solid ${active === type ? '#0DB14B ' : '#fff'}`,
          }}
        >
          {text}
        </WhiteBox>
      </Box>
    </Button>
  );
};

export default Counter;
